/**
 * CSV セル値のエスケープ (RFC 4180 準拠 + CWE-1236 formula injection 対策)。
 *
 * 1. 先頭の空白・制御文字を飛ばして `= + - @` が現れる場合はアポストロフィを
 *    前置して数式評価を抑止する (CWE-1236。Excel は先頭タブ等を無視して評価)。
 *    値自体がアポストロフィで始まる場合も前置する (= 取込側が先頭 1 文字を
 *    落とすだけで元の値に戻せる = エスケープを可逆にするため)
 * 2. カンマ・ダブルクォート・改行 (LF/CR) を含む場合はダブルクォートで囲み、
 *    内部のダブルクォートは `""` にエスケープする
 *
 * CSV を出力する画面が複数ある (広域マスタ = `AdminOcctoMaster/tabs/_common/
 * models/csvExport.ts`、48 点データ = `~/models/supply48DataCsv`) ため、
 * エスケープ規則だけをアプリ横断の libs に置く (= 規則が画面ごとに分岐すると
 * formula injection 対策の抜けが特定の画面にだけ生じる)。
 */
export function escapeCsvCell(value: string): string {
  let safe = value
  if (/^[\s\t\r\n]*['=+\-@]/.test(safe)) {
    safe = `'${safe}`
  }
  if (
    safe.includes(',') ||
    safe.includes('"') ||
    safe.includes('\n') ||
    safe.includes('\r')
  ) {
    return `"${safe.replaceAll('"', '""')}"`
  }
  return safe
}
